<div class="abandonedReservation__cont" *ngIf="hasAbandonedReservation$ | async">
  <ng-container [ngSwitch]="detailType">
    <ng-container *ngSwitchCase="reservationType.Hotel">
      <app-abandoned-hotel-reservation 
        [itinerary]="abandonedReservation$ | async"
        [user]="user$ | async"
        [isMobile]="isMobile$ | async"
        [reservationType]="detailType"
        [isLoadingCancellation]="isLoadingCancellation$ | async"
        (cancelEvent)="cancelAbandonedReservation($event)">
      </app-abandoned-hotel-reservation>
    </ng-container>
    <ng-container *ngSwitchCase="reservationType.Flight">
      <app-abandoned-flight-reservation 
        [itinerary]="abandonedReservation$ | async"
        [user]="user$ | async"
        [isMobile]="isMobile$ | async"
        [reservationType]="detailType"
        [isLoadingCancellation]="isLoadingCancellation$ | async"
        (cancelEvent)="cancelAbandonedReservation($event)">
      </app-abandoned-flight-reservation>
    </ng-container>
    <ng-container *ngSwitchCase="reservationType.Auto">
      <app-abandoned-auto-reservation 
        [itinerary]="abandonedReservation$ | async"
        [user]="user$ | async"
        [isMobile]="isMobile$ | async"
        [reservationType]="detailType"
        [isLoadingCancellation]="isLoadingCancellation$ | async"
        (cancelEvent)="cancelAbandonedReservation($event)">
      </app-abandoned-auto-reservation>
    </ng-container>
    <ng-container *ngSwitchCase="reservationType.AirPackage">
      <app-abandoned-air-package-reservation 
        [itinerary]="abandonedReservation$ | async"
        [user]="user$ | async"
        [isMobile]="isMobile$ | async"
        [reservationType]="detailType"
        [isLoadingCancellation]="isLoadingCancellation$ | async"
        (cancelEvent)="cancelAbandonedReservation($event)">
      </app-abandoned-air-package-reservation>
    </ng-container>
    <ng-container *ngSwitchCase="reservationType.Extra">
      <app-extra-retarget 
        [itinerary]="abandonedReservation$ | async"
        [user]="user$ | async"
        [isMobile]="isMobile$ | async"
        [reservationType]="detailType"
        [isLoadingCancellation]="isLoadingCancellation$ | async"
        (cancelEvent)="cancelAbandonedReservation($event)">
      </app-extra-retarget>
    </ng-container>
  </ng-container>
</div>